import { TFunction } from 'i18next';
import { SsoConfigTab } from './constants';

export default function getConfigTabOptions(t: TFunction) {
  return [
    { value: SsoConfigTab.Attributes, label: t('attributes') },
    { value: SsoConfigTab.Provisioning, label: t('provisioning') },
    { value: SsoConfigTab.Advanced, label: t('advanced') },
  ];
}
